import React, { useContext, useState, useEffect } from "react";
import calendarOutlineBadged from '@iconify-icons/clarity/calendar-outline-badged';
import { AtendimentoContext } from "../../../contexts/AtendimentoContext";
import DatePicker from "react-date-picker/dist/entry";
import "./DatePicker.scss";
import { Icon } from "@iconify/react";
import caAPI from '../../../services/caAPI';
import moment from 'moment'

moment.locale('pt-br')

const converterParaData = (valor) => {
  if(!valor) {
    return moment().startOf('day').toDate()
  }
  if(valor instanceof Date) {
    return valor
  }
  if(typeof valor === 'string' && valor.length === 10) {
    return moment(valor, 'YYYY-MM-DD').toDate()
  }
  return new Date(valor)
}

function AtendimentoIntervaloDatasPicker({tipoBusca = null}){
  const { handleAtualizaLista, filtro, buscandoAtendimentos } = useContext(AtendimentoContext);
  const buscaPorCriacao = tipoBusca == 2 || Boolean(filtro?.data_criacao_inicio)
  const chaveInicio = buscaPorCriacao ? 'data_criacao_inicio' : 'data_inicio'
  const chaveFim = buscaPorCriacao ? 'data_criacao_fim' : 'data_fim'
  const chaveInicioOposta = buscaPorCriacao ? 'data_inicio' : 'data_criacao_inicio'
  const chaveFimOposta = buscaPorCriacao ? 'data_fim' : 'data_criacao_fim'
  const [dataInicio, setDataInicio] = useState(converterParaData(filtro?.[chaveInicio]));
  const [dataFim, setDataFim] = useState(converterParaData(filtro?.[chaveFim]))

  useEffect(() => {
    setDataInicio(converterParaData(filtro?.[chaveInicio]))
    setDataFim(converterParaData(filtro?.[chaveFim]))
  },[filtro, buscaPorCriacao])

  const atualizarFiltroData = (chave, dateCalendar) => {
    const novosFiltros = Object.assign({}, filtro, {[chave]: dateCalendar})
    delete novosFiltros[chaveInicioOposta];
    delete novosFiltros[chaveFimOposta];

    const filtrosSalvos = Object.assign(JSON.parse(caAPI.getLocalState('filtros') || "{}"), {[chave]: dateCalendar});
    delete filtrosSalvos[chaveInicioOposta];
    delete filtrosSalvos[chaveFimOposta];
    caAPI.setLocalState('filtros', JSON.stringify(filtrosSalvos));
    handleAtualizaLista(novosFiltros, { limparAtendimentoAtivo: true });
  }

  const handleChangeDate = (dateCalendar) => {
    if(buscandoAtendimentos) {
      return
    }
    setDataInicio(dateCalendar);
    if (!filtro?.[chaveInicio] || (dateCalendar.getTime() !== converterParaData(filtro[chaveInicio]).getTime())) {
      atualizarFiltroData(chaveInicio, dateCalendar)
    }
  };

  const handleChangeDateFim = (dateCalendar) => {
    if(buscandoAtendimentos) {
      return
    }
    setDataFim(dateCalendar);
    if (!filtro?.[chaveFim] || (dateCalendar.getTime() !== converterParaData(filtro[chaveFim]).getTime())) {
      atualizarFiltroData(chaveFim, dateCalendar)
    }
  };
  return <>
  <DatePicker
    onChange={handleChangeDate}
    value={dataInicio}
    disabled={buscandoAtendimentos}
    format="dd/MM/yyyy"
    calendarIcon={<Icon icon={calendarOutlineBadged} width="20" style={{ color: '#f58442' }}/>}
    clearIcon={null}
  /> <DatePicker
    onChange={handleChangeDateFim}
    value={dataFim}
    disabled={buscandoAtendimentos}
    format="dd/MM/yyyy"
    calendarIcon={<Icon icon={calendarOutlineBadged} width="20" style={{ color: '#f58442' }}/>}
    clearIcon={null}
  />
  </>
}

export default AtendimentoIntervaloDatasPicker;
